import AMCustomToastNotification from '@components/shared/toast-notifications/AMCustomToastNotification';
import ToastNotification from '@components/shared/toast-notifications/ToastNotification';
import { theme } from '@theme';
import { toast } from 'react-toastify';
import { checkMobileDevice } from './CheckMobileDevice';

export const SuccessToast = (
  toastMessage: string,
  autoClose: number | false = ToastDuration.fiveSeconds,
) => {
  const { isMobileDevice, isLandscape } = checkMobileDevice();

  return toast.success(
    <ToastNotification
      toastMessage={toastMessage}
      iconType='checkmark'
      iconColor={theme.palette.white}
      leftIndicatorColor={theme.palette.success}
      backgroundColor={theme.palette.success}
    />,
    {
      autoClose: autoClose,
      closeButton: isMobileDevice,
      className: `${isMobileDevice ? `am-mobile-toast success${isLandscape ? ' toast-landscape' : ''}` : ''}`,
    },
  );
};

export const ErrorToast = (
  toastMessage: string,
  autoClose: number | false = ToastDuration.fiveSeconds,
) => {
  const { isMobileDevice, isLandscape } = checkMobileDevice();

  return toast.error(
    <ToastNotification
      toastMessage={toastMessage}
      iconType='x-circle-full'
      iconColor={theme.palette.white}
      leftIndicatorColor={theme.palette.danger}
    />,
    {
      autoClose: autoClose,
      closeButton: isMobileDevice,
      className: `${isMobileDevice ? `am-mobile-toast error${isLandscape ? ' toast-landscape' : ''}` : ''}`,
    },
  );
};

export const InfoToast = (
  toastMessage: string,
  autoClose: number | false = ToastDuration.fiveSeconds,
  closeButton: boolean = false,
) => {
  const { isMobileDevice, isLandscape } = checkMobileDevice();

  return toast.info(
    <ToastNotification
      toastMessage={toastMessage}
      iconType='info'
      iconColor={theme.palette.white}
      leftIndicatorColor={theme.palette.infoBlue}
    />,
    {
      autoClose: autoClose,
      closeButton: isMobileDevice ? true : closeButton,
      className: `${isMobileDevice ? `am-mobile-toast info${isLandscape ? ' toast-landscape' : ''}` : ''}`,
    },
  );
};

export const WarningToast = (
  toastMessage: string,
  autoClose: number | false = ToastDuration.fiveSeconds,
) => {
  const { isMobileDevice, isLandscape } = checkMobileDevice();

  return toast.warning(
    <ToastNotification
      toastMessage={toastMessage}
      iconType='warning'
      iconColor={theme.palette.white}
      leftIndicatorColor={theme.palette.orangeWarning}
    />,
    {
      autoClose: autoClose,
      closeButton: isMobileDevice,
      className: `${isMobileDevice ? `am-mobile-toast warning${isLandscape ? ' toast-landscape' : ''}` : ''}`,
    },
  );
};

export const AMCustomToast = (
  toastMessage: JSX.Element,
  autoClose: number | false = ToastDuration.fiveSeconds,
  closeButton: boolean = false,
) => {
  return toast.info(<AMCustomToastNotification toastMessage={toastMessage} />, {
    autoClose: autoClose,
    closeButton: closeButton,
    className: 'am-custom-toast',
  });
};

export const DismissAllToasts = () => {
  toast.dismiss();
};

export enum ToastDuration {
  oneSecond = 1000,
  twoSeconds = 2000,
  threeSeconds = 3000,
  fourSeconds = 4000,
  fiveSeconds = 5000,
}
